import { useConfig } from '@/composables/useConfig';
import { useLogger } from '@/composables/useLogger';

export const useUla = () => {
  const { getConfig } = useConfig();
  const { logger } = useLogger();

  const sendMessageToUla = (message: string) => {
    const iframe = document.querySelector('#ulaIframe') as HTMLIFrameElement;
    iframe?.contentWindow?.postMessage(message, getConfig().ULA_URL);
  };

  const loadUserInfo = (): void => {
    sendMessageToUla('getUserInfo');
  };

  const logout = (): Promise<void> => {
    const abortController = new AbortController();
    sendMessageToUla('logout');
    return new Promise((resolve) => {
      globalThis.addEventListener(
        'message',
        (e) => {
          if (e.origin === getConfig().ULA_URL && e.data.name === 'ula-logout') {
            logger.info('>>> ULA logout completed');
            abortController.abort();
            resolve();
          }
        },
        { signal: abortController.signal },
      );
    });
  };

  const getIdToken = (): Promise<string | null> => {
    const abortController = new AbortController();
    sendMessageToUla('getIdToken');
    return new Promise((resolve) => {
      globalThis.addEventListener(
        'message',
        (e) => {
          if (e.origin === getConfig().ULA_URL && e.data.name === 'ula-id-token') {
            abortController.abort();
            resolve(e.data.idToken ?? null);
          }
        },
        { signal: abortController.signal },
      );
    });
  };

  return {
    loadUserInfo,
    logout,
    getIdToken,
  };
};
